<template>
    <div class="c-app">
        <CWrapper v-if="this.store.myUser.onlineTrainingDoScreenPhotosExhibitionMode">
            <!--suppress HtmlUnknownAttribute -->
            <div style="user-select: none; min-height: 500px; float:left; width: 100%;" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">
                <div style="user-select: none; width: 100%; align-content: center; float: left;" v-for="thumbnailId in this.store.myUser.onlineTrainingLastExhibitionScreenThumbnailsIds.slice(startImgNum, startImgNum+3)" :key="thumbnailId">
                    <!--suppress HtmlRequiredAltAttribute -->
                    <CLink style="user-select: none;" draggable="false" :to="{name: 'exhibition-photo', params: {thumbnailId: thumbnailId}}"><p>{{thumbnailId }}</p></CLink>
                    <CImg draggable="false" :src="fileUrl(thumbnailId)" style="user-select: none; display: block; margin-left: auto; margin-right: auto; width: 60%;margin-bottom: 20px"/>
                </div>
            </div>
        </CWrapper>
    </div>
</template>

<script>
import {store} from '@/scripts/globals'
import fileUtils from "@/mixins/file-utils";

export default {
    mixins: [fileUtils],
    data() {
        return {
            store,
            startImgNum: 0
        }
    },
    methods : {
        swipeLeft () {
            this.startImgNum = this.startImgNum+3
            if (this.startImgNum > 39 || this.startImgNum > this.store.myUser.onlineTrainingLastExhibitionScreenThumbnailsIds.length-2)
                this.startImgNum = this.store.myUser.onlineTrainingLastExhibitionScreenThumbnailsIds.length-2
        },
        swipeRight () {
            this.startImgNum = this.startImgNum-3
            if (this.startImgNum < 0)
                this.startImgNum = 0
        }
    }
}
</script>

<style scoped>

</style>